const routeAuth = () => '/auth';

export default routeAuth;